// Api.
import api from './Base';

// Types.
import Parameter from '../types/Parameter';
import { showError } from '../utils/showAlert';

// Interface for the payload when saving parameters
export interface ParameterToSave {
    name: string;
    value: string;
}

// Interface for the payload when updating existing parameters
export interface ParameterToUpdate {
    name: string;
    value: string;
}

// Interface for the payload when deleting parameters
export interface ParameterToDelete {
    name: string;
    value: string;
}

const ParameterApi = {
    getParameters: async (): Promise<Parameter[]> => {
        const url = `parameter`;
        let parametersList: Parameter[] = [];
        try {
            const response = await api.get<Parameter[]>(url);
            if (response?.data) {
                parametersList = response.data;
            }
        } catch (error: any) {
            console.error('Failed to retrieve parameters.', error);
            showError('Failed to retrieve parameters', error.message || error.toString());
        }
        return parametersList;
    },

    getProperties: async (): Promise<Parameter[]> => {
        const url = `property`;
        let propertiesList: Parameter[] = [];
        try {
            const response = await api.get<Parameter[]>(url);
            if (response?.data) {
                propertiesList = response.data;
            }
        } catch (error: any) {
            console.error('Failed to retrieve properties.', error);
            showError('Failed to retrieve properties', error.message || error.toString());
        }
        return propertiesList;
    },

    saveParameter: async (parameter: ParameterToSave): Promise<any> => {
        const url = `parameter`;
        try {
            // Send as array to match backend expectations
            const response = await api.post<any>(url, [parameter]);
            return response.data;
        } catch (error: any) {
            console.error('Failed to save parameter.', error);
            showError('Failed to save parameter', error.message || error.toString());
            throw error;
        }
    },

    updateParameter: async (parameter: ParameterToUpdate): Promise<any> => {
        const url = `parameter`;
        try {
            // Send as array to match backend expectations
            const response = await api.put<any>(url, [parameter]);
            return response.data;
        } catch (error: any) {
            console.error('Failed to update parameter.', error);
            showError('Failed to update parameter', error.message || error.toString());
            throw error;
        }
    },

    deleteParameter: async (parametersToDelete: ParameterToDelete[]): Promise<any> => {
        const url = `parameter`;
        try {
            const response = await api.delete<any>(url, { data: parametersToDelete });
            return response.data;
        } catch (error: any) {
            console.error('Failed to delete parameters.', error);
            showError('Failed to delete parameters', error.message || error.toString());
            throw error;
        }
    },
};

export default ParameterApi;
